import { useLocalStorageSafe } from '@mews/framework';
import { LocalStorageKey } from '@mews-commander/enums';
import { useCurrentEnterpriseId, useCurrentProfileId } from '@mews-commander/core';
import { productCheckListDefaultFiltersSchema } from '../components/panels/ProductCheckListFilterFields/types';

export const useProductChecklistFiltersStorage = () => {
    const enterpriseId = useCurrentEnterpriseId();
    const profileId = useCurrentProfileId();
    const localStorageKey = `${LocalStorageKey.productChecklistFilters}-${profileId}-${enterpriseId}`;
    // @ts-expect-error
    return useLocalStorageSafe(localStorageKey, productCheckListDefaultFiltersSchema);
};
